// extracted by mini-css-extract-plugin
export default {"documentWrap":"index_documentWrap__FInAa","mainLayout":"index_mainLayout__goB7T","spinWrap":"index_spinWrap__l20S+","drawer":"index_drawer__zJVXg"};